import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SaveExportXmpMetadataToSequenceMutationVariables = Types.Exact<{
  sequenceId: Types.Scalars['ID']['input'];
  includeInOutTimestamps: Types.Scalars['Boolean']['input'];
  xmpMetadata: Types.SequenceXmpMetadataInput;
}>;


export type SaveExportXmpMetadataToSequenceMutation = { __typename?: 'Mutation', saveExportXmpMetadataToSequence?: { __typename?: 'PremiereSequence', id?: string | null, metadata?: Array<{ __typename?: 'SequenceExportsXMPMetadata', exportedAt: number, assetId: string, versionId?: string | null, shareId?: string | null, projectId: string, accountId: string, sequenceId?: string | null, sequenceIn?: number | null, sequenceOut?: number | null } | { __typename?: 'V3PanelExportsXMPMetadata' } | { __typename?: 'V4CommentsPanelExportsXMPMetadata', exportedAt: number, shareId?: string | null } | null> | null } | null };


export const SaveExportXmpMetadataToSequence = /*#__PURE__*/ gql`
    mutation SaveExportXmpMetadataToSequence($sequenceId: ID!, $includeInOutTimestamps: Boolean!, $xmpMetadata: SequenceXMPMetadataInput!) {
  saveExportXmpMetadataToSequence(
    sequenceId: $sequenceId
    includeInOutTimestamps: $includeInOutTimestamps
    xmpMetadata: $xmpMetadata
  ) {
    id
    metadata {
      ... on SequenceExportsXMPMetadata {
        exportedAt
        assetId
        versionId
        shareId
        projectId
        accountId
        sequenceId
        sequenceIn
        sequenceOut
      }
      ... on V4CommentsPanelExportsXMPMetadata {
        exportedAt
        shareId
      }
    }
  }
}
    ` as unknown as DocumentNode<SaveExportXmpMetadataToSequenceMutation, SaveExportXmpMetadataToSequenceMutationVariables>;

          

          export const useSaveExportXmpMetadataToSequenceMutation = (options?:MutationHookOptions<SaveExportXmpMetadataToSequenceMutation, SaveExportXmpMetadataToSequenceMutationVariables>) => useMutation(SaveExportXmpMetadataToSequence, options);
          

          export type SaveExportXmpMetadataToSequenceMutationOptions = MutationHookOptions<SaveExportXmpMetadataToSequenceMutation, SaveExportXmpMetadataToSequenceMutationVariables>;

          

          export type SaveExportXmpMetadataToSequenceMutationResult = ReturnType<typeof useSaveExportXmpMetadataToSequenceMutation>[1];

          
